import { ADD_INCIDENT_EMAIL, FETCH_INCIDENT_DETAIL } from "../actionTypes"
import { fetchIncidentDetail } from "../../../api/incidentManagement/incidentDetail.service"
import { addAdditionalEmail } from "../../../api/incidentManagement/raiseIncident.service"

const incidentDetailRequest = ()=>({type: FETCH_INCIDENT_DETAIL.REQUEST})
const incidentDetailFailure = (error)=>({type: FETCH_INCIDENT_DETAIL.FAILURE, error})
const incidentDetailSuccess = (obj)=>({type: FETCH_INCIDENT_DETAIL.SUCCESS, obj})

export const getIncidentDetail = (requestId)=>{
    return (dispatch, getState)=>{        
        dispatch(incidentDetailRequest())
        return fetchIncidentDetail(requestId)
        .then(response => {
            dispatch(incidentDetailSuccess(response))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(incidentDetailFailure(error?.message))
            return Promise.resolve(false)
        })
    }
}

const addEmailRequest = ()=>({type: ADD_INCIDENT_EMAIL.REQUEST})
const addEmailFailure = (error)=>({type: ADD_INCIDENT_EMAIL.FAILURE, error})
const addEmailSuccess = (obj)=>({type: ADD_INCIDENT_EMAIL.SUCCESS, obj})

export const addEmail = (payload,id) => {
  return (dispatch, getState) => {
    dispatch(addEmailRequest());
    return addAdditionalEmail(payload,id)
      .then((res) => {
        dispatch(addEmailSuccess(res));
        return Promise.resolve({res:res,status:true});

      })
      .catch((error) => {
        dispatch(addEmailFailure(error?.message));
        return Promise.resolve({error:error?.message,status:false,code:error?.code});
      })
  }
}